import ContextModel from "../../Activity/Models/RequestBody/Context/ContextModel";

export default class CreatePostParamBody {
  public content: string = "";
  public replyId: string | null = "";
  public discussionLabel?: string | null = "";
  public discussionUrl?: string | null = "";
  public userNickname: string | null = "";
  public context: ContextModel = null;
}
